import ReportsTab from './ReportsTab';

export default ReportsTab;
